import React from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";
const HEADER_HIGHLIGHT = "rgba(6, 182, 164, 0.08)";

const thStyle = (sortable, highlighted) => ({
  padding: "12px 16px",
  color: "#475569",
  fontWeight: "600",
  fontSize: "13px",
  whiteSpace: "nowrap",
  background: highlighted ? HEADER_HIGHLIGHT : "#f8fafc",
});

function EmptyRow({ colSpan }) {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-5">
        <div className="d-flex flex-column align-items-center justify-content-center text-muted">
          <i className="fa fa-exclamation-triangle mb-2" style={{ fontSize: "28px", color: "#f59e0b" }} aria-hidden />
          <span style={{ fontSize: "15px" }}>No data available.</span>
        </div>
      </td>
    </tr>
  );
}

export default function ManageProfiles() {
  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header with Create Profile button */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
            <div>
              <h3 className="text-primary mb-2">Manage Profiles</h3>
              <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <NavLink to="/overview">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <span style={{ color: "#64748b" }}>Invest Online BSE</span> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">Manage Profiles</li>
                </ol>
              </nav>
            </div>
            <NavLink
              to="/Invest-application"
              className="btn flex-shrink-0 text-decoration-none"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "14px",
                padding: "10px 20px",
              }}
            >
              Create Profile
            </NavLink>
          </div>
        </div>

        {/* Complete / Ongoing */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-body p-0">
            <h5 className="p-4 pb-2 mb-0" style={{ fontWeight: "700", color: "#334155" }}>
              Complete / Ongoing
            </h5>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th style={thStyle(false, false)}>BSE Name/PAN</th>
                    <th style={thStyle(true, true)}>
                      ARN <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                    </th>
                    <th style={thStyle(false, false)}>UCC No</th>
                    <th style={thStyle(false, false)}>UCC Type</th>
                    <th style={thStyle(false, false)}>Tax Status</th>
                    <th style={thStyle(false, false)}>Mode of Holding</th>
                    <th style={thStyle(false, false)}>Joint Name 1</th>
                    <th style={thStyle(false, false)}>Joint Name 2</th>
                    <th style={thStyle(false, false)}>Status</th>
                    <th style={thStyle(false, false)}>Nomination Auth Date</th>
                    <th style={thStyle(false, false)}>Actions</th>
                  </tr>
                </thead>
                <tbody style={{ background: "#fff" }}>
                  <EmptyRow colSpan={11} />
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Pending */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-body p-0">
            <h5 className="p-4 pb-2 mb-0" style={{ fontWeight: "700", color: "#334155" }}>
              Pending
            </h5>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th style={thStyle(true, true)}>
                      Name/PAN <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                    </th>
                    <th style={thStyle(true, false)}>
                      Mode of Holding <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                    </th>
                    <th style={thStyle(false, false)}>Joint Name 1</th>
                    <th style={thStyle(false, false)}>Joint Name 2</th>
                    <th style={thStyle(false, false)}>Status</th>
                  </tr>
                </thead>
                <tbody style={{ background: "#fff" }}>
                  <EmptyRow colSpan={5} />
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Mandates */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <div className="card-body p-0">
            <h5 className="p-4 pb-2 mb-0" style={{ fontWeight: "700", color: "#334155" }}>
              Mandates
            </h5>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead>
                  <tr>
                    <th style={thStyle(false, false)}>ARN</th>
                    <th style={thStyle(false, false)}>UCC</th>
                    <th style={thStyle(false, false)}>Name</th>
                    <th style={thStyle(false, false)}>Account</th>
                    <th style={thStyle(false, false)}>Bank</th>
                    <th style={thStyle(false, false)}>Start Date</th>
                    <th style={thStyle(false, false)}>End Date</th>
                    <th style={thStyle(false, false)}>UMRN</th>
                    <th style={thStyle(false, false)}>BSE Mandate Code</th>
                    <th style={thStyle(false, false)}>Amount Type</th>
                    <th style={thStyle(false, false)}>Status</th>
                    <th style={thStyle(false, false)}>Actions</th>
                  </tr>
                </thead>
                <tbody style={{ background: "#fff" }}>
                  <EmptyRow colSpan={12} />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
